import React, { Suspense as SuspenseReact } from 'react';
import LoadingDots from './loading-dots';

const Suspense = ({ children }) => <SuspenseReact fallback={<LoadingDots />}>{children}</SuspenseReact>;

export default Suspense;
